var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wlx-stu-manager-wrapper"},[_c('div',{staticClass:"u-school-manager-head stu-manager-head-con clearfix"}),_c('div',{staticClass:"u-table-main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }